import {AuthHttp} from './index.js'

class AuthenticatedUserAPI {
  constructor () {
    this.resource = '/me'
  }
  get () {
    return AuthHttp.get(`${this.resource}`)
  }
}
export default new AuthenticatedUserAPI()
